import React from "react";
import { Outlet } from "react-router-dom";
import MFooterNavigation from "../ui/atoms/MFooterNavigation";

/**
 * ProfileLayout: Used for 3rd Level Screens.
 * Renders main content
 */
const ProfileLayout: React.FC<
  React.PropsWithChildren<{ hideFooterNav?: true | false }>
> = ({ children, hideFooterNav = false }) => {
  return (
    <div className="flex flex-col">
      <main className="flex-1 min-h-0 flex flex-col overflow-x-hidden">
        {children ? children : <Outlet />}
      </main>
      {!hideFooterNav && <MFooterNavigation />}
    </div>
  );
};

export default ProfileLayout;
